import React, { Component } from 'react';
import "./toolbar.css";
import Search from "./Search"

export default class ToolbarSimple2 extends Component {
  render() {
    return (
      <div className="col-12 row d-flex justify-content-between">
            <div className="col-md-6 row">
                <div className="titulo d-flex align-items-center">
                    <img width={35} className="" src={this.props.icono} alt="Usuario" />
                    <span className="ml-2 text-uppercase text-titulo"><strong>{this.props.titulo}</strong></span>
                    <span className={`ml-2 text-uppercase text-titulo ${this.props.css}`}><strong>{this.props.subtitulo}</strong></span>
                </div>
            </div>
            <div className="col-lg-4 col-md-4 p-0 text-right search">
                {(this.props.buscar !== undefined) && (
                <Search buscar={this.props.buscar} buscador={this.props.buscador}/>
                )}
            </div>
      </div>
    )
  }
}
